// extracted by mini-css-extract-plugin
module.exports = {"requestHeader":"requestHeader__1mcEn","requestSwitcherText":"requestSwitcherText__2jMK2"};